import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getPaymentStore = (state: RootState) => state.paymentStore;
const getPaymentsLabel = createSelector(getPaymentStore, (state) => state.paymentsLabel);

export { getPaymentsLabel };
